<template>
  <div v-if="access !== null">
    <EditSOSPopUp
      :activate="active"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passData"
      :kategoriList="kategoriList"
    />
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <header class="w-full">
        <div class="mb-base mt-4 vx-row justify-between items-top">
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
            <span class="text-black text-2xl">Tabel SOS</span>
          </section>
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
            <vs-button @click="toAdd()" v-if="access.create === 1">Tambah SOS</vs-button>
          </section>
        </div>
        <div class="vx-row justify-between items-center">
          <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <vs-button icon-after icon="expand_more">Aksi</vs-button>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="dialogDelete" v-if="access.delete === 1">
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">{{ `entries ${limit}` }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(item, index) in limitDataTables"
                    :key="index"
                    @click="limit = item"
                  >
                    <span>{{ item }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="vx-row justify-end items-center">
              <v-select
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full lg:mr-0"
                v-model="kat_id"
                :reduce="(v) => v.id"
                :options="kategoriList"
                label="name"
                placeholder="Pilih Kategori"
              />
              <v-select
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full"
                v-model="filterType"
                :reduce="(v) => v.data"
                :options="[
                  {
                    data: 'kontak',
                    text: 'Kontak',
                  },
                  {
                    data: 'pic',
                    text: 'PIC',
                  },
                ]"
                label="text"
                placeholder="Aksi Bulk"
              />
              <vs-input
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full"
                v-model="search"
                placeholder="Cari..."
              />
            </div>
          </section>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        ></div>
      </header>

      <main ref="loadSOS">
        <vs-table stripe :data="sosList" v-model="selected" :max-items="limit" multiple>
          <template slot="thead">
            <vs-th>Nama SOS</vs-th>
            <vs-th>PIC</vs-th>
            <vs-th>Kontak</vs-th>
            <vs-th>Alamat</vs-th>
            <vs-th>Kategori</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>Aksi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>
              <vs-td :data="data[indextr].pic">
                {{ data[indextr].pic }}
              </vs-td>
              <vs-td :data="data[indextr].kontak">
                {{ data[indextr].kontak }}
              </vs-td>
              <vs-td :data="data[indextr].alamat">
                {{ data[indextr].alamat }}
              </vs-td>
              <vs-td
                :data="
                  data[indextr].sub_kategori
                    ? data[indextr].sub_kategori.kategori
                      ? data[indextr].sub_kategori.kategori.name
                      : null
                    : null
                "
              >
                {{
                  data[indextr].sub_kategori
                    ? data[indextr].sub_kategori.kategori
                      ? data[indextr].sub_kategori.kategori.name
                      : "(Data Kosong)"
                    : "(Data Kosong)"
                }}
              </vs-td>
              <vs-td>
                <div
                  v-if="
                    syaratKumpuls(data[indextr].id).length !== 0 &&
                    persyaratanList(data[indextr].sub_kategori.id).length !== 0
                  "
                >
                  <span
                    v-if="syaratKumpuls.length !== 0"
                    :style="
                      syaratKumpuls(data[indextr].id).filter((v) => v.status === 1)
                        .length === persyaratanList(data[indextr].sub_kategori.id).length
                        ? 'color: green;'
                        : 'color: red;'
                    "
                    >{{
                      syaratKumpuls(data[indextr].id).filter((v) => v.status === 1)
                        .length === persyaratanList(data[indextr].sub_kategori.id).length
                        ? "Disetujui"
                        : "Belum Disetujui"
                    }}</span
                  >
                  <span v-else style="color: red"> Belum Disetujui </span>
                </div>
                <span style="color: red" v-else> Belum Disetujui </span>
              </vs-td>
              <vs-td>
                <div class="flex justify-start gap-2">
                  <vs-button
                    v-if="access.update === 1"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click="toEdit(data[indextr].id)"
                  >
                  </vs-button>
                  <vs-button
                    v-if="access.delete === 1"
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="dialogDelete(data[indextr].id, data[indextr].name)"
                  >
                  </vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </main>
      <footer>
        <div class="justify-end mt-2">
          <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
        </div>
      </footer>
    </vx-card>
  </div>
</template>

<script>
import EditSOSPopUp from "@/views/sos/component/EditSOSPopUp.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";

export default {
  components: {
    EditSOSPopUp,
    emptyImage,
  },
  data() {
    return {
      params: {},
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      kategoriList: [],
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      passData: null,
      selected: [],
      filterType: "",
      kat_id: null,
      currentPg: 1,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      sosList: [],
      access: null,
      search: "",
    };
  },
  watch: {
    filter: {
      handler(v) {
        let searchObj = {};
        let katObj = {};

        if (v.search !== "") {
          searchObj = {
            search: this.search,
            filter: this.filterType !== "" ? this.filterType : "name",
          };
        } else {
          searchObj = {};
        }

        if (v.kategori !== null) {
          katObj = {
            kat_id: this.kat_id,
          };
        } else {
          katObj = {};
        }

        this.params = { ...searchObj, ...katObj };
        this.getData();
      },
      deep: true,
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData();
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData();
    },
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    filter() {
      return {
        kategori: this.kat_id,
        search: this.search,
      };
    },
    totalPage() {
      let pages = this.$store.state.sos.totalRecords / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
  },
  methods: {
    persyaratanList(idSubKategori) {
      return this.$store.getters["sos/getFilteredSyarat"](idSubKategori);
    },
    syaratKumpuls(idSOS) {
      return this.$store.getters["sos/getFilteredSyaratKumpul"](idSOS);
    },
    toEdit(id) {
      this.$router.push(`/dashboard/sos/${id}/edit`).then(() => {});
    },
    toAdd() {
      this.$router.push("/dashboard/sos/add").then(() => {});
    },
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    loadData(val) {
      if (val) {
        this.getData();
      }
    },
    openPopUp(item) {
      this.active = true;
      this.passData = item;
    },
    getSubKategoriSOS() {
      this.$store
        .dispatch("sos/getSubKategoriSOS", {})
        .then((v) => {
          this.subKategoriList = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getKategoriSOS() {
      this.$store
        .dispatch("sos/getKategoriSOS", {})
        .then((v) => {
          this.kategoriList = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadSOS,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("sos/cudSOS", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `SOS ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSOS);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getSyarat() {
      this.$store.dispatch("sos/getSyaratSOS", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
    getSyaratKumpul() {
      this.$store.dispatch("sos/getSyaratKumpulSOS", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadSOS,
        color: "primary",
      });
      let user = {};
      if (this.profile.level.id != 2) {
        user = {
          user_id: this.profile.id,
        };
      }
      this.$store
        .dispatch("sos/getSOS", { ...this.params, ...user, ...this.pagination })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadSOS);
          this.sosList = v.data.filter((v) => v.kat_id !== null && v.sub_id !== null);
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSOS);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    this.getData();
    if (this.$store.state.sos.kategoriSOSList.length === 0) {
      this.getKategoriSOS();
    } else {
      this.kategoriList = this.$store.state.sos.kategoriSOSList;
    }

    if (this.$store.state.sos.subKategoriSOSList.length === 0) {
      this.getSubKategoriSOS();
    }
    if (this.$store.state.sos.syaratList.length === 0) {
      this.getSyarat();
    }
    if (this.$store.state.sos.syaratKumpuls.length === 0) {
      this.getSyaratKumpul();
    }
  },
  created() {
    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/sos"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/sos"
        );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
